import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'llcFormatter'
})
export class LlcFormatter implements PipeTransform {
  transform(value: string): unknown {
    const correctlyFormattedValue = value.replace(/Llc/, 'LLC');
    return correctlyFormattedValue;
  }
}
